import InvoiceIcon from '@material-ui/icons/LibraryBooks';
import InvoiceList from './InvoiceList';
import InvoiceShow from './InvoiceShow';

export default {
    list: InvoiceList,
    show: InvoiceShow,
    icon: InvoiceIcon
};
